// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"SB-z","smallCardRow":"TB-z","largeCardRow":"UB-z","productSearchRow":"VB-z","curatedRow":"WB-z"};